import { render, staticRenderFns } from "./TheInteractContractLayout.vue?vue&type=template&id=3b621ff2&"
import script from "./TheInteractContractLayout.vue?vue&type=script&lang=js&"
export * from "./TheInteractContractLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports